import { Component, Input, OnInit } from '@angular/core';
import { Access, Guest } from 'src/app/interfaces/access';
import { FunctionsService } from 'src/app/services/functions/functions.service';

@Component({
  selector: 'app-manager-coupons-share',
  templateUrl: './manager-coupons-share.page.html',
  styleUrls: ['./manager-coupons-share.page.scss'],
})
export class ManagerCouponsSharePage implements OnInit {

  @Input() targets: Guest[];
  @Input() coupon: Access;
  @Input() type: string;
  @Input() couponImg: any;
  message: string;

  constructor(
    public funcServ: FunctionsService
  ) { }

  ngOnInit() {
    this.generateMessage();
    console.log('holaaa');
    console.log(this.message);
    console.log(this.targets, this.type);
    console.log(this.couponImg);
  }

  generateMessage() {
    this.message = this.coupon.id + ' // ' + this.coupon.name + '. ';
    this.message += this.coupon.note;
    // tslint:disable-next-line:no-unused-expression
    this.coupon.coupon.limit ? this.message += ' ¡Limitado a ' + this.coupon.coupon.limit + ' cupones!' : null;

  }

  share2Whatsapp(target: Guest) {
    const phoneNumber = target.phoneNumbers[0];
    window.open('https://wa.me/' + phoneNumber + '?text=' + this.message, '_blank');
  }

  share2Facebook(target: Guest) {
    console.log(target);
  }

  share2SMS(target: Guest) {
    console.log(target);
  }
}
